import { HelpIcon } from '@dixa/lib-shared-habla';
import { Component } from 'react';
import AceEditor from 'react-ace';

import Spinner from '../../ajax/components/Spinner';
import 'brace/ext/language_tools';
import 'brace/mode/handlebars';
import 'brace/mode/json';
import 'brace/mode/html';
import 'brace/theme/tomorrow';

type PropsT = {
  name: string | null;
  displayName: string;
  height: string | number;
  disabled: boolean | null;
  hidden: boolean | null;
  required: boolean | null;
  placeholder: string;
  defaultHidden: boolean | null;
  input: any;
  meta: any;
  previewButton: any;
  previewContent: any;
  showSpinner: boolean;
  className: string | null;
  showHelpIcon: boolean | null;
  helpIconTitle: string;
  helpIconText: string;
  onChangeAction: ((e: any) => void) | null;
};

type StateT = {
  showTemplateContent: boolean;
};

/** @deprecated Use FieldTemplate in `src/components/fieldTemplate` instead */
class TemplateField extends Component<PropsT, StateT> {
  static defaultProps: Partial<PropsT>;

  constructor(props: PropsT) {
    super(props);
    this.state = {
      showTemplateContent: this.props.defaultHidden === true ? false : true,
    };
  }

  render() {
    const {
      name,
      displayName,
      previewButton,
      previewContent,
      height,
      hidden,
      disabled,
      required,
      input,
      meta,
      showSpinner,
      className,
      showHelpIcon,
      helpIconTitle,
      helpIconText,
      onChangeAction,
      defaultHidden,
    } = this.props;

    let formGroupClasses =
      className && typeof className === 'string' ? className : '';
    let validationErrors: JSX.Element | null = null;
    let spinner: JSX.Element | null = null;
    let helpIcon: JSX.Element | null = null;
    if (meta?.visited && meta?.valid) {
      formGroupClasses += ' has-success';
    } else if (meta?.visited && meta?.error) {
      formGroupClasses += ' has-error';
      validationErrors = <span className="validation-text">{meta.error}</span>;
    }

    if (hidden === true) {
      formGroupClasses += ' hidden';
    }

    if (disabled === true) {
      formGroupClasses += ' disabled';
    }

    if (showSpinner === true) {
      spinner = <Spinner className="dark input" />;
    }

    if (showHelpIcon === true) {
      helpIcon = <HelpIcon text={helpIconText} title={helpIconTitle} />;
    }

    return (
      <div className={`form-group ${formGroupClasses}`}>
        <div>
          {displayName !== '' && (
            <label className="control-label" htmlFor={name as string}>
              {displayName} {required === true ? '*' : ''} {validationErrors}
            </label>
          )}
          {helpIcon}
          {previewButton ? previewButton : null}
        </div>
        <div>
          {previewContent ? previewContent : null}
          {this.state.showTemplateContent && !previewContent && (
            <AceEditor
              onFocus={input.onFocus}
              mode="handlebars"
              theme="tomorrow"
              name="template"
              onChange={(e: any) => {
                if (typeof onChangeAction === 'function') {
                  onChangeAction(e);
                }
                input.onChange(e);
              }}
              fontSize={14}
              width="100%"
              height={height as any}
              showPrintMargin={false}
              showGutter={false}
              highlightActiveLine={true}
              value={input.value}
              setOptions={{
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true,
                enableSnippets: false,
                showLineNumbers: true,
                tabSize: 2,
              }}
            />
          )}
          {defaultHidden && !this.state.showTemplateContent ? (
            <div>
              <span style={{ marginLeft: 10 }}>
                If you want to customize this template click{' '}
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.setState({ showTemplateContent: true })}
                >
                  HERE
                </a>
              </span>
            </div>
          ) : null}
          {spinner}
        </div>
      </div>
    );
  }
}

TemplateField.defaultProps = {
  height: '250px',
  disabled: false,
  hidden: false,
  required: false,
  className: '',
  showSpinner: false,
  onChangeAction: null,
  placeholder: '',
};

export default TemplateField;
